// https://vimeo.com/channels/staffpicks
export const vimeoChannelURLRegExp =
  /^(?:https:\/\/)?(?:[a-z]{2,3}\.)?vimeo\.[a-z]{2,3}\/channels\/([^/]+)/;
// https://vimeo.com/groups/musicvideo
export const vimeoGroupURLRegExp =
  /^(?:https:\/\/)?(?:[a-z]{2,3}\.)?vimeo\.[a-z]{2,3}\/groups\/([^/]+)/;
// https://vimeo.com/aicp
export const vimeoUserURLRegExp =
  /^(?:https:\/\/)?(?:[a-z]{2,3}\.)?vimeo\.[a-z]{2,3}\/([^/]+)/;
// https://vimeo.com/showcase/8643175
export const vimeoShowcaseURLRegExp =
  /^(?:https:\/\/)?(?:[a-z]{2,3}\.)?vimeo\.[a-z]{2,3}\/showcase\/(\d+)/;
// https://vimeo.com/914864510
export const vimeoSpecificVideoURLRegExp =
  /^(?:https:\/\/)?(?:[a-z]{2,3}\.)?vimeo\.[a-z]{2,3}\/(\d+)/;
